export default __webpack_public_path__ + "static/media/img3.89805f86.jpg";